import './Question.scss';
// @ts-ignore 
import ScrollOut from 'scroll-out';
import Splitting from 'splitting';
import React, { useEffect, useContext } from 'react';
import TranslateText from '../../translation/TranslateText';
import { LanguageContext } from '../../LanguageContext';
import useGoogleTranslateLanguage from 'translation/useGoogleTranslateLanguage'; 

function Questions() {
  const detectedLanguage = useGoogleTranslateLanguage();

  const questions = {
    en: [
      "WHAT IS A CREDIT SWEEP?",
      "ARE CREDIT SWEEPS LEGAL?",
      "HOW MUCH DOES IT COST?",
      "SHOULD I CLOSE MY OLD CREDIT CARDS?!",
      "WHAT IS THE DIFFERENCE BETWEEN AN ELITE CREDIT REPAIR AND A STANDARD CREDIT REPAIR?",
      "HOW LONG DOES IT TAKE?",
      "IS CREDIT INQUIRY REMOVAL INCLUDED IN THE CREDIT SWEEP?",
      "WHAT IS YOUR REFUND POLICY?",
      "ARE CREDIT SWEEPS EFFECTIVE?"
    ],
    es: [
      "¿QUÉ ES UN BARRIDO DE CRÉDITO?",
      "¿SON LEGALES LOS BARRIDOS DE CRÉDITO?",
      "¿CUÁNTO CUESTA?",
      "¿DEBERÍA CERRAR MIS TARJETAS DE CRÉDITO ANTIGUAS?",
      "¿CUÁL ES LA DIFERENCIA ENTRE UNA REPARACIÓN DE CRÉDITO ELITE Y UNA REPARACIÓN DE CRÉDITO ESTÁNDAR?",
      "¿CUÁNTO TIEMPO TOMA?",
      "¿ESTÁ INCLUIDA LA ELIMINACIÓN DE CONSULTAS DE CRÉDITO EN EL BARRIDO DE CRÉDITO?",
      "¿CUÁL ES SU POLÍTICA DE REEMBOLSO?",
      "¿SON EFECTIVOS LOS BARRIDOS DE CRÉDITO?"
    ]
  };

  useEffect(() => {
    console.clear();

    ScrollOut({
      cssProps: {
        visibleY: true,
        viewportY: true
      }
    });

    Splitting({ target: '.heading' });
  }, []); // Empty dependency array ensures the effect runs only once after the component mounts

  return (
    <>
      {/* Question 1 */}
      <section className="content-section" style={{ backgroundColor: 'purple' }} data-scroll>
        <figure className="figure">
          {/* <img src="" alt="" /> */}
        </figure>
        <div className="content">
          <header className="header">
            <div className="subheading"></div>
            <h2 className="heading notranslate" translate="no">
              {questions[detectedLanguage][0]}
            </h2>
          </header>
          <p className="paragraph3">
            <TranslateText text="A proprietary process for removing negative items from your credit report, opening up more possibilities for your financial future. We do this extremely fast in comparison to traditional credit repair. We perform the work with modern strategies to accommodate the ever changing industry. Deletions start occurring within the first 60 days. For most clients, the best results happen within the first 45 – 60 days." />
          </p>
        </div>
      </section>

      {/* Question 2 */}
      <section className="content-section" style={{ backgroundColor: 'silver' }} data-scroll>
        <figure className="figure">
          {/* <img src="" alt="" /> */}
        </figure>
        <div className="content">
          <header className="header">
            <div className="subheading"></div>
            <h2 className="heading notranslate" translate="no">
              {questions[detectedLanguage][1]}
            </h2>
          </header>
          <p className="paragraph3">
            <TranslateText text="A credit sweep is a form of credit repair which is 100% legal and it works because of the law. The Fair Credit Reporting Act (FCRA) gives you the right to dispute any item on your credit report. If an item cannot be verified, it must be removed. This is the basis of all credit repair. The FCRA is a U.S. Government legislation enacted to promote the accuracy, fairness and privacy of consumer information contained in the files of consumer reporting agencies. It is intended to protect consumers from willful and or negligent inclusion of inaccurate information on their credit reports." />
          </p>
        </div>
      </section>

      {/* Question 3 */}
      <section className="content-section" style={{ backgroundColor: 'purple' }} data-scroll>
        <figure className="figure">
        </figure>
        <div className="content">
          <header className="header">
            <div className="subheading"></div>
            <h2 className="heading notranslate" translate="no">
              {questions[detectedLanguage][2]}
            </h2>
          </header>
          <p className="paragraph3">
            <TranslateText text="We have made it AFFORDABLE to everyone. Give us a call to see which plan will work best for you given your goals and outcome." />
          </p>
        </div>
      </section>

      {/* Question 4 */}
      <section className="content-section" style={{ backgroundColor: 'silver' }} data-scroll>
        <figure className="figure">
          {/* <img src="" alt="" /> */}
        </figure>
        <div className="content">
          <header className="header">
            <div className="subheading"></div>
            <h2 className="heading notranslate" translate="no">
              {questions[detectedLanguage][3]}
            </h2>
          </header>
          <p className="paragraph3">
            <TranslateText text="NO WAY! Old established seasoned accounts are built into your account history which is a huge chunk of your credit score. If you have old credit card accounts that you want to stop using, just cut up the cards or keep them in a drawer, but keep the accounts open. If you close an account, you can expect an immediate drop in your credit score because it will decrease the average age of your credit history. Old accounts are your positive credit. Positive credit takes YEARS to build and if you ever needed to purchase it in the form of a tradeline, it is very expensive. Your old accounts are important, do not close them." />
          </p>
        </div>
      </section>

      {/* Question 5 */}
      <section className="content-section" style={{ backgroundColor: 'purple' }} data-scroll>
        <figure className="figure">
          {/* <img src="" alt="" /> */}
        </figure>
        <div className="content">
          <header className="header">
            <div className="subheading"></div>
            <h2 className="heading notranslate" translate="no">
              {questions[detectedLanguage][4]}
            </h2>
          </header>
          <p className="paragraph3">
            <TranslateText text="The main difference is the time frame, fee schedule and process. Our Elite Credit Repair is proprietary, and extremely expedited in comparison to our Standard Credit Repair. Deletions start occurring within the first 60 days. For most clients, the best results happen within the 45 days. The Standard Credit Repair will take 90 days, which will be a longer time frame, deletions will start occurring within the first 60-75 days." />
          </p>
        </div>
      </section>

      {/* Question 6 */}
      <section className="content-section" style={{ backgroundColor: 'silver' }} data-scroll>
        <figure className="figure">
          {/* <img src="" alt="" /> */}
        </figure>
        <div className="content">
          <header className="header">
            <div className="subheading"></div>
            <h2 className="heading notranslate" translate="no">
              {questions[detectedLanguage][5]}
            </h2>
          </header>
          <p className="paragraph3">
            <TranslateText text="What takes other companies 9-14 months takes us ONLY 60 – 90 days for the first round of results. Every credit report is different. If additional rounds are needed, it will be an additional 30 days for each round. Note that you will continue seeing improvement throughout this entire process given you follow our guidance to maintain your results and empower a lifetime of good credit decisions." />
          </p>
        </div>
      </section>

      {/* Question 7 */}
      <section className="content-section" style={{ backgroundColor: 'purple' }} data-scroll>
        <figure className="figure">
          {/* <img src="" alt="" /> */}
        </figure>
        <div className="content">
          <header className="header">
            <div className="subheading"></div>
            <h2 className="heading notranslate" translate="no">
              {questions[detectedLanguage][6]}
            </h2>
          </header>
          <p className="paragraph3">
            <TranslateText text="No, this is a completely separate service as it requires a completely different method. Do you need to remove pesky credit inquiries? If you have too many, you will get DENIED more frequently which will hold you back from getting the things you want in your life. We can remove certain pesky inquiries (up to 100 credit inquiries across all three credit bureaus). Typical results are 60 – 90 days. We have a phenomenal bundle discount if you purchase inquiry removal with your credit sweep." />
          </p>
        </div>
      </section>

      {/* Question 8 */}
      <section className="content-section" style={{ backgroundColor: 'silver' }} data-scroll>
        <figure className="figure">
          {/* <img src="" alt="" /> */}
        </figure>
        <div className="content">
          <header className="header">
            <div className="subheading"></div>
            <h2 className="heading notranslate" translate="no">
              {questions[detectedLanguage][7]}
            </h2>
          </header>
          <p className="paragraph3">
            <TranslateText text="EVERY credit report that we work on has improvement! If we do not produce results, then we have no business accepting your money. We guarantee your credit score will improve otherwise we will refund your money. Disclaimer: If you have a new derogatory account, run up your credit card balances over 30%, miss a payment, and/or have multiple new credit inquiries, we can see this and it will cause a reduction in your credit score, ultimately undoing all of the progress we made. Don’t do that to yourself!" />
          </p>
        </div>
      </section>

      {/* Question 9 */}
      <section className="content-section" style={{ backgroundColor: 'purple' }} data-scroll>
        <figure className="figure">
          {/* <img src="" alt="" /> */}
        </figure>
        <div className="content">
          <header className="header">
            <div className="subheading"></div>
            <h2 className="heading notranslate" translate="no">
              {questions[detectedLanguage][8]}
            </h2>
          </header>
          <p className="paragraph3">
            <TranslateText text="ABSOLUTELY! This is highly effective for a credit score after a collection, delinquency, bankruptcy, divorce, Identity theft, judgement, late payment, or foreclosure. We work on all of these.79% of all credit reports contain errors! This means that most credit reports can be improved instantly. We work on correcting inaccurate and misleading personal data on your credit report. Also inaccurate and unverifiable credit and collection information must be complete, accurate and verifiable otherwise you have the right to dispute the account." />
          </p>
        </div>
      </section>
    </>
  );
}

export default Questions;





// import './Question.scss'
// // @ts-ignore 
// import ScrollOut from 'scroll-out';
// import Splitting from 'splitting';
// import Logo from './Logo';

// import React, { useEffect } from 'react';

// function Questions() {
//   useEffect(() => {
//     console.clear();

//     ScrollOut({
//       cssProps: {
//         visibleY: true,
//         viewportY: true
//       }
//     });

//     Splitting({ target: '.heading' });
//   }, []); // Empty dependency array ensures the effect runs only once after the component mounts

//   return (
//     <>
      
//       {/* Photos via Unsplash Source https://source.unsplash.com/ */}
//       {/* Question 1 */}

      
//       <section className="content-section" style={{ backgroundColor: 'purple' }} data-scroll>
//         <figure className="figure">
//           <img src="" alt="" />
//         </figure>
        
        
//         <div className="content">
//           <header className="header">
//             <div className="subheading"></div>
//             <h2 className="heading notranslate" translate="no">WHAT IS A CREDIT SWEEP?<br /></h2>
//           </header>
//           <p className="paragraph3">
//           A proprietary process for removing negative items from your credit report,
// opening up more possibilities for your financial future.
// We do this extremely fast in comparison to traditional credit repair.
// We perform the work with modern strategies to 
// accommodate the ever changing industry.
// Deletions start occurring within the first 60 days.
// For most clients, the best results happen within the first 45 – 60 days.
//           </p>
//         </div>
//       </section>

//         {/* Question 2 */}

//       <section className="content-section" style={{ backgroundColor: 'silver' }} data-scroll>
//         <figure className="figure">
//           <img src="" alt="" />
//         </figure>
//         <div className="content">
//           <header className="header">
//             <div className="subheading"></div>
//             <h2 className="heading notranslate" translate="no">ARE CREDIT SWEEPS LEGAL?<br /></h2>
//           </header>
//           <p className="paragraph3">
//           A credit sweep is a form of credit repair which is 100% legal and it works because of the law.
// The Fair Credit Reporting Act (FCRA) gives you the right to dispute any item on your credit report.
// If an item cannot be verified, it must be removed.
// This is the basis of all credit repair.
// The FCRA is a U.S. Government legislation enacted to promote the accuracy,
// fairness and privacy of consumer information contained in the files of consumer reporting agencies.
// It is intended to protect consumers from willful and or negligent inclusion of inaccurate information on their credit reports.
//           </p>
          
//         </div>
//       </section>

//         {/* Question 3 */}

//       <section className="content-section" style={{ backgroundColor: 'purple' }} data-scroll>
//         <figure className="figure">
//           {/* <video autoPlay loop muted>
//           <source src={require("assets/img/Money.mp4")} type="video/mp4" />
//             Your browser does not support the video tag.
//         </video> */}
      
//         </figure>
//         <div className="content">
//           <header className="header">
//             <div className="subheading"></div>
//             <h2 className="heading notranslate" translate="no">HOW MUCH DOES IT COST?<br /></h2>
//           </header>
//           <p className="paragraph3">
//           We have made it AFFORDABLE to everyone. Give us a call to see which plan will work best for you given your goals and outcome.
//           </p>
//         </div>


//         {/* Question 4 */}
//       </section>
//       <section className="content-section" style={{ backgroundColor: 'silver' }}data-scroll>
//         <figure className="figure">
//           <img src="" alt="" />
//         </figure>
//         <div className="content">
//           <header className="header">
//             <div className="subheading"></div>
//             <h2 className="heading notranslate" translate="no">SHOULD I CLOSE MY OLD CREDIT CARDS?!<br /></h2>
//           </header>
//           <p className="paragraph3">
//           NO WAY! Old established seasoned accounts are built into your account history which is a huge chunk of your credit score.
// If you have old credit card accounts that you want to stop using, just cut up the cards or keep them in a drawer, but keep the accounts open.
// If you close an account, you can expect an immediate drop in your credit score because it will decrease the average age of your credit history.
// Old accounts are your positive credit. Positive credit takes YEARS to build and if you ever needed to purchase it in the form of a tradeline, it is very expensive.
// Your old accounts are important, do not close them.
//           </p>
//         </div>
//       </section>

//         {/* Question 5 */}


//       <section className="content-section" style={{ backgroundColor: 'purple' }} data-scroll>
//         <figure className="figure">
//           <img src="" alt="" />
//         </figure>
//         <div className="content">
//           <header className="header">
//             <div className="subheading"></div>
//             <h2 className="heading notranslate" translate="no">WHAT IS THE DIFFERENCE BETWEEN AN ELITE CREDIT REPAIR AND A STANDARD CREDIT REPAIR?<br /></h2>
//           </header>
//           <p className="paragraph3">
//           The main difference is the time frame, fee schedule and process. Our Elite Credit Repair is proprietary, and extremely expedited in comparison to our Standard Credit Repair. Deletions start occurring within the first 60 days. For most clients, the best results happen within the 45 days. The Standard Credit Repair will take 90 days, which will be a longer time frame, deletions will start occurring within the first 60-75 days.
//           </p>
//         </div>
//       </section>
      
//         {/* Question 6 */}
//       <section className="content-section" style={{ backgroundColor: 'silver' }} data-scroll>
//         <figure className="figure">
//           <img src="" alt="" />
//         </figure>
//         <div className="content">
//           <header className="header">
//             <div className="subheading"></div>
//             <h2 className="heading notranslate" translate="no">HOW LONG DOES IT TAKE?<br /></h2>
//           </header>
//           <p className="paragraph3">
//           What takes other companies 9-14 months takes us ONLY 60 – 90 days for the first round of results.
// Every credit report is different. If additional rounds are needed, it will be an additional 30 days for each round. Note that you will continue seeing improvement throughout this entire process given you follow our guidance to maintain your results and empower a lifetime of good credit decisions.
//           </p>
//         </div>
//       </section>

//   {/* Question 7 */}
      
//       <section className="content-section" style={{ backgroundColor: 'purple' }} data-scroll>
//         <figure className="figure">
//           <img src="" alt="" />
//         </figure>
//         <div className="content">
//           <header className="header">
//             <div className="subheading"></div>
//             <h2 className="heading notranslate" translate="no">IS CREDIT INQUIRY REMOVAL INCLUDED IN THE CREDIT SWEEP?
// <br /></h2>
//           </header>
//           <p className="paragraph3">
//           No, this is a completely separate service as it requires a completely different method. 
// Do you need to remove pesky credit inquiries? If you have too many, you will get DENIED more frequently which will hold you back from getting the things you want in your life.
// We can remove certain pesky inquiries (up to 100 credit inquiries across all three credit bureaus).
// Typical results are 60 – 90 days. We have a phenomenal bundle discount if you purchase inquiry removal with your credit sweep.
//           </p>
//         </div>
//       </section>

//         {/* Question 8 */}
//       <section className="content-section" style={{ backgroundColor: 'silver' }} data-scroll>
//         <figure className="figure">
//           <img src="" alt="" />
//         </figure>
//         <div className="content">
//           <header className="header">
//             <div className="subheading"></div>
//             <h2 className="heading notranslate" translate="no">WHAT IS YOUR REFUND POLICY?<br /></h2>
//           </header>
//           <p className="paragraph3">
//           EVERY credit report that we work on has improvement! If we do not produce results, then we have no business accepting your money. We guarantee your credit score will improve otherwise we will refund your money.
// Disclaimer: If you have a new derogatory account, run up your credit card balances over 30%, miss a payment, and/or have multiple new credit inquiries, we can see this and it will cause a reduction in your credit score, ultimately undoing all of the progress we made. Don’t do that to yourself!
//           </p>
//         </div>
//       </section>

//         {/* Question 9 */}
//       <section className="content-section" style={{ backgroundColor: 'purple' }} data-scroll>
//         <figure className="figure">
//           <img src="" alt="" />
//         </figure>
//         <div className="content">
//           <header className="header">
//             <div className="subheading"></div>
//             <h2 className="heading notranslate" translate="no">ARE CREDIT SWEEPS EFFECTIVE?<br /></h2>
//           </header>
//           <p className="paragraph3">
//           ABSOLUTELY! This is highly effective for a credit score after a collection, delinquency, bankruptcy, divorce, Identity theft, judgement, late payment, or foreclosure. We work on all of these.79% of all credit reports contain errors! This means that most credit reports can be improved instantly. We work on correcting inaccurate and misleading personal data on your credit report. Also inaccurate and unverifiable credit and collection information must be complete, accurate and verifiable otherwise you have the right to dispute the account.
//           </p>
//         </div>
//       </section>

//     </>
//   );
// }

// export default Questions;










// import './Boost.css'

// function Questions() {
//   const flexStyle = {
//     display: 'flex',
//     flexWrap: 'wrap', // If you want to wrap items to the next line
//   };
//   return (
//     <div className='Questions' style={flexStyle} >


//         <div className='learn3 center boost-container2 question'>
//             <span className="large-text3">ARE CREDIT SWEEPS </span>
//             <span className="large-text3">LEGAL? </span>
//             <div className="separator3"></div>
//             <span className='large-text2'>A credit sweep is a form of credit repair</span>
//             <span className='large-text2'>which is 100% legal and it works</span>  
//             <span className='large-text2'>because of the law.</span>  
//             <span className='large-text2'>The Fair Credit Reporting Act (FCRA)</span>  
//             <span className='large-text2'>gives you the right to dispute any item</span>  
//             <span className='large-text2'>on your credit report.</span>  
//             <span className='large-text2'>If an item cannot be verified, it must be</span>  
//             <span className='large-text2'>removed.</span>  
//             <span className='large-text2'>This is the basis of all credit repair.</span>  
//             <span className='large-text2'>The FCRA is a U.S. Government </span>  
//             <span className='large-text2'>legislation enacted to promote the </span>  
//             <span className='large-text2'>accuracy,</span>  
//             <span className='large-text2'>fairness and privacy of consumer </span>  
//             <span className='large-text2'>information contained in the files of</span>  
//             <span className='large-text2'>consumer reporting agencies.</span>  
//             <span className='large-text2'>It is intended to protect consumers from</span>  
//             <span className='large-text2'>willful and or negligent inclusion of </span>  
//             <span className='large-text2'>inaccurate information on their credit</span>  
//             <span className='large-text2'>reports.</span>  
//         </div>

//         <div className='learn3 center boost-container2 question'>
//             <span className="large-text3">WHAT IS A CREDIT SWEEP? </span>
//             <div className="separator3"></div>
//             <span className="large-text2">A proprietary process for removing</span>
//             <span className="large-text2">negative items from your credit report,</span>
//             <span className="large-text2">opening up more possibilities for your</span>
//             <span className="large-text2">financial future.</span>
//             <span className="large-text2">We do this extremely fast in </span>
//             <span className="large-text2">comparison to traditional credit repair.</span>
//             <span className="large-text2">We perform the work with modern </span>
//             <span className="large-text2">strategies to </span>
//             <span className="large-text2">accommodate the ever changing </span>
//             <span className="large-text2">industry.</span>
//             <span className="large-text2">Deletions start occurring within the </span>
//             <span className="large-text2">first 60 days.</span>
//             <span className="large-text2">happen within the first 45-60 days.</span>
//         </div>

//         <div className='learn3 center boost-container2 question'>
//             <span className="large-text3">HOW MUCH DOES IT</span>
//             <span className="large-text3">COST?</span>
//             <div className="separator3"></div>
//             <span className='large-text2'>We have made it AFFORDABLE to </span>
//             <span className='large-text2'>everyone. Give us a call to see which </span>
//             <span className='large-text2'>plan will work best for you given your</span>
//             <span className='large-text2'>goals and outcome.</span>
//         </div>

//         <div className='learn3 center boost-container2 question'>
//             <span className="large-text3">SHOULD I CLOSE MY </span>
//             <span className="large-text3">OLD CREDIT CARDS?!</span>
//             <div className="separator3"></div>

//             <span className='large-text2'>NO WAY! Old established seasoned</span>
//             <span className='large-text2'>accounts are built into your account </span>
//             <span className='large-text2'>history which is a huge chunk of your</span>
//             <span className='large-text2'>credit score.</span>
//             <span className='large-text2'>If you have old credit card accounts </span>
//             <span className='large-text2'>that you want to stop using, just cut up</span>
//             <span className='large-text2'>the cards or keep them in a drawer, but</span>
//             <span className='large-text2'>keep the accounts open.</span>
//             <span className='large-text2'>If you close an account, you can</span>
//             <span className='large-text2'>expect an immediate drop in your </span>
//             <span className='large-text2'>credit score because it will decrease</span>
//             <span className='large-text2'>the average age of your credit history.</span>
//             <span className='large-text2'>Old accounts are your positive credit.</span>
//             <span className='large-text2'>Positive credit takes YEARS to build </span>
//             <span className='large-text2'>and if you ever needed to purchase it</span>
//             <span className='large-text2'>in the form of a tradeline, it is very</span>
//             <span className='large-text2'>expensive.</span>
//             <span className='large-text2'>Your old accounts are important, do</span>
//             <span className='large-text2'>not close them.</span>

//         </div>

//         <div className='learn3 center boost-container2 question'>
//             <span className="large-text3">WHAT IS THE</span>
//             <span className="large-text3">DIFFERENCE</span>
//             <div className="large-text3">BETWEEN AN ELITE</div>
//             <div className="large-text3">CREDIT REPAIR AND</div>
//             <div className="large-text3">A STANDARD CREDIT</div>
//             <div className="large-text3">REPAIR?</div>
//             <div className="separator3"></div>



//             <span className='large-text2'>The main difference is the time frame,</span>
//             <span className='large-text2'>fee schedule and process. Our Elite </span>
//             <span className='large-text2'>Credit Repair is proprietary, and </span>
//             <span className='large-text2'>extremely expedited in comparison to</span>
//             <span className='large-text2'>our Standard Credit Repair. Deletions </span>
//             <span className='large-text2'>start occurring within the first 60 days. </span>
//             <span className='large-text2'>For most clients, the best results </span>
//             <span className='large-text2'>happen within the 45 days. The </span>
//             <span className='large-text2'>Standard Credit Repair will take 90 </span>
//             <span className='large-text2'>days, which will be a longer time frame,</span>
//             <span className='large-text2'>deletions will start occurring within the</span>
//             <span className='large-text2'>first 60-75 days.</span>

            
//         </div>

//         <div className='learn3 center boost-container2 question'>
//             <span className="large-text3">IS CREDIT INQUIRY</span>
//             <span className="large-text3">REMOVAL INCLUDED</span>
//             <span className="large-text3">IN THE CREDIT</span>
//             <span className="large-text3">SWEEP?</span>

//             <div className="separator3"></div>

//             <span className='large-text2'>No, this is a completely separate </span>
//             <span className='large-text2'>service as it requires a completely</span>
//             <span className='large-text2'>different method.</span>
//             <span className='large-text2'>Do you need to remove pesky credit </span>
//             <span className='large-text2'>inquiries? If you have too many, you </span>
//             <span className='large-text2'>will get DENIED more frequently which </span>
//             <span className='large-text2'>will hold you back from getting the</span>
//             <span className='large-text2'>things you want in your life.</span>
//             <span className='large-text2'>We can remove certain pesky inquiries</span>
//             <span className='large-text2'>(up to 100 credit inquiries across all </span>
//             <span className='large-text2'>three credit bureaus).</span>
//             <span className='large-text2'>Typical results are 60-90 days. We </span>
//             <span className='large-text2'>have a phenomenal bundle discount if </span>
//             <span className='large-text2'>you purchase inquiry removal with your</span>
//             <span className='large-text2'>credit sweep.</span>

            
//         </div>

//         <div className='learn3 center boost-container2 question'>
//             <span className="large-text3">HOW LONG DOES IT</span>
//             <span className="large-text3">TAKE?</span>
//             <div className="separator3"></div>

//             <span className='large-text2'>What takes other companies 9-14 </span>
//             <span className='large-text2'>months takes us ONLY 60-90 days </span>
//             <span className='large-text2'>for the first round of results.</span>
//             <span className='large-text2'>Every credit report is different. If </span>
//             <span className='large-text2'>additional rounds are needed, it will be </span>
//             <span className='large-text2'>an additional 30 days for each round. </span>
//             <span className='large-text2'>Note that you will continue seeing </span>
//             <span className='large-text2'>improvement throughout this entire </span>
//             <span className='large-text2'>process given you follow our guidance </span>
//             <span className='large-text2'>to maintain your results and empower</span>
//             <span className='large-text2'>a lifetime of good credit decisions.</span>


            
//         </div>

//         <div className='learn3 center boost-container2 question'>
//             <span className="large-text3">ARE CREDIT SWEEPS</span>
//             <span className="large-text3">EFFECTIVE?</span>
//             <div className="separator3"></div>

//             <span className='large-text2'>ABSOLUTELY! This is highly effective </span>
//             <span className='large-text2'>for a credit score after a collection, </span>
//             <span className='large-text2'>delinquency, bankruptcy, divorce, </span>
//             <span className='large-text2'>Identity theft, judgement, late </span>
//             <span className='large-text2'>payment, or foreclosure. We work on </span>
//             <span className='large-text2'>all of these.</span>
//             <span className='large-text2'>79% of all credit reports contain errors! </span>
//             <span className='large-text2'>This means that most credit reports</span>
//             <span className='large-text2'>can be improved instantly. We work on </span>
//             <span className='large-text2'>correcting inaccurate and misleading </span>
//             <span className='large-text2'>personal data on your credit report. </span>
//             <span className='large-text2'>Also inaccurate and unverifiable credit </span>
//             <span className='large-text2'>and collection information must be</span>
//             <span className='large-text2'>complete, accurate and verifiable </span>
//             <span className='large-text2'>otherwise you have the right to dispute </span>
//             <span className='large-text2'>the account.</span>

            
//         </div>

//         <div className='learn3 center boost-container2 question'>
//             <span className="large-text3">WHAT IS YOUR</span>
//             <span className="large-text3">REFUND POLICY?</span>
//             <div className="separator3"></div>

//             <span className='large-text2'>EVERY credit report that we work on </span>
//             <span className='large-text2'>has improvement! If we do not produce</span>
//             <span className='large-text2'>results, then we have no business </span>
//             <span className='large-text2'>accepting your money. We guarantee </span>
//             <span className='large-text2'>your credit score will improve </span>
//             <span className='large-text2'>otherwise we will refund your money.</span>
//             <span className='large-text2'>Disclaimer: If you have a new </span>
//             <span className='large-text2'>derogatory account, run up your credit </span>
//             <span className='large-text2'>card balances over 30%, miss a </span>
//             <span className='large-text2'>payment, and/or have multiple new</span>
//             <span className='large-text2'>credit inquiries, we can see this and it</span>
//             <span className='large-text2'>will cause a reduction in your credit </span>
//             <span className='large-text2'>score, ultimately undoing all of the</span>
//             <span className='large-text2'>progress we made. Don't do that to </span>
//             <span className='large-text2'>yourself!</span>

            
//         </div>



//     </div>
//   )
// }

// export default Questions
